import { cn } from "../../lib/utils";

type StatusBadgeProps = {
  status: "up" | "down" | "warning" | "unknown";
  className?: string;
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const statusClasses = {
    up: "bg-secondary bg-opacity-10 text-secondary",
    down: "bg-danger bg-opacity-10 text-danger",
    warning: "bg-warning bg-opacity-10 text-warning",
    unknown: "bg-gray-100 text-gray-500",
  };

  const statusText = {
    up: "Up",
    down: "Down",
    warning: "Warning",
    unknown: "Unknown",
  };

  return (
    <span
      className={cn(
        "px-2 inline-flex text-xs leading-5 font-semibold rounded-full",
        statusClasses[status],
        className
      )}
    >
      {statusText[status]}
    </span>
  );
}
